import styled from 'styled-components';
import media from '~/client/shared/media';
import Stack from '~/client/shared/Stack';

const Container = styled(Stack)`
  && {
    display: flex;
    ${media.desktopSmall} {
      display: none;
    }
  }
`;

const LiveRtpTabs: FC = ({ children }) => <Container>{children}</Container>;

export default LiveRtpTabs;
